import React from 'react'
import cn from 'classnames'
import { Typography } from '@grammarly/badger-ui'
import { VerticalTabContent } from '../types'
import { ImageAsset } from '../../../asset/image'
import { ComponentLink } from '../../../item/link/component-link'
import { renderRichTextSingleLineContent } from '../../../renderer/rich-text'
import styles from './tab-content.module.scss'

export interface TabContentProps {
  content: VerticalTabContent
  id?: string
  associatedTriggerId?: string
  className?: string
}

export const TabContent: React.FC<TabContentProps> = ({ content, id, associatedTriggerId, className }) => {
  return (
    <div id={id} className={cn(styles.container, className)} role="region" aria-labelledby={associatedTriggerId}>
      <ImageAsset className={styles.image} structure={content.image} />

      <section className={styles.content}>
        <Typography.HS className={styles.title} as="h4">
          {content.title}
        </Typography.HS>
        <Typography.TL as="p">{renderRichTextSingleLineContent(content.description)}</Typography.TL>
        <ComponentLink className={styles.link} isEmbedded targetLink={content.link} />
      </section>
    </div>
  )
}
